import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import IconLogoFacebook from '../atoms/assets/icons/IconLogoFacebook';
import IconLogoLinkedin from '../atoms/assets/icons/IconLogoLinkedin';
import IconLogoTwitter from '../atoms/assets/icons/IconLogoTwitter';

const Holder = styled.div`
	margin-top: 3rem;
  a { margin-right: 1.5rem; }
  a > svg { fill: ${props => props.theme.colours.link} }
`;

class SharingIcons extends Component {
    state = {
        fbAppId: 488729542030177,
        url: '',
        title: '',
        desc: '',
    }

    componentDidMount() {
        const { shareURL, shareTitle, shareDesc } = this.props;

        /*eslint no-extend-native: ["error", { "exceptions": ["String"] }]*/
        String.prototype.allReplace = function(obj) {
            let retStr = this;
            for (const x in obj) {
                retStr = retStr.replace(new RegExp(x, 'g'), obj[x]);
            }
            return retStr;
        };

        let url = shareURL.allReplace({':': '%3A', '/': '%2F'});
        let title = shareTitle.allReplace({' ': '%20',':': '%3A', '/': '%2F'});
        let desc = shareDesc.allReplace({" ": "%20",":": "%3A", "/": "%2F", "'": "%27"});
        this.setState( { url: url, title: title, desc: desc } );
    }


    render() {
        const { fbAppId, url, title, desc } = this.state;

        return (
            <Holder>
            	<h5>Share your avatars</h5>
                <a target="_blank" rel="noopener noreferrer" href={`https://www.facebook.com/dialog/feed?app_id=${fbAppId}&display=popup&link=${url}`}>
	            	<IconLogoFacebook />
            	</a>
		        <a target="_blank" rel="noopener noreferrer" href={`https://twitter.com/intent/tweet?text=${desc}&via=ttclabs`}>
		        	<IconLogoTwitter />
	        	</a>
		        <a target="_blank" rel="noopener noreferrer" href={`https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}`}>
		        	<IconLogoLinkedin />
	        	</a>
            </Holder>
        )
    }
}

SharingIcons.propTypes = {
  shareURL: PropTypes.string,
  shareTitle: PropTypes.string,
  shareDesc: PropTypes.string,
  fbAppId: PropTypes.number,
};

export default SharingIcons;